module.exports = __webpack_public_path__ + "static/media/paymentfail.cec45ef2.png";